import * as React from 'react'
import {Util} from 'yougile-util'
import {cn} from '@containers/html-utils'

type IconName =
  | 'chat-subscribe'
  | 'chat-unsubscribe'
  | 'add-user-on-light'
  | 'main-menu-close'
  | 'main-menu-help'
  | 'add'
  | 'tick-gray'
  | 'untick'
  | 'tick'
  | 'delete-task'

const bem = Util.bemFrom('icon')

export const Icon = ({
  name,
  className,
  ...rest
}: {
  name: IconName
} & React.HTMLAttributes<HTMLSpanElement>) => (
  <span className={cn(className, bem(name))} {...rest} />
)
